import { AutoCompleteSelectBox } from 'src/components/AutoCompleteSelectBox';
import { SkillCard } from './SkillCard';
import useAuthedRequest from 'src/hooks/useAuthedRequest';
import { QueryObject } from 'src/interfaces/queryObject.interface';
import { Number } from 'src/interfaces/number.interface';
import { processPhoneNumber } from 'src/utils/number';
import { useCallback, useState } from 'react';

type InCallSmsConfig = {
  phone_number: string;
};

export const validateInCallSmsConfig = (
  config: InCallSmsConfig | undefined,
): boolean => {
  if (!config || !config.phone_number) {
    return false;
  }
  return !!config.phone_number.trim();
};

export function InCallSmsSkill({
  config,
  onConfigChange,
}: {
  config: InCallSmsConfig;
  onConfigChange?: (config: InCallSmsConfig) => void;
}) {
  const [callerNumber, setCallerNumber] = useState<string>(
    config.phone_number ?? '',
  );
  const { get } = useAuthedRequest();
  const searchCallerNumbers = useCallback(
    async (query: string) => {
      const queryObject: QueryObject = {
        page: '1',
        size: '50',
        filters: JSON.stringify({ number: query, smsEnabled: true }),
      };
      const queryString = new URLSearchParams(
        queryObject as Record<string, string>,
      ).toString();
      const data = await get(`/numbers?${queryString}`);
      return data.items.map((item: Number) => ({
        value: item.number,
        label: processPhoneNumber(item.number),
      }));
    },
    [get],
  );
  return (
    <SkillCard description="Set the phone number to send SMSs from during a call">
      <div className="mb-4">
        <AutoCompleteSelectBox
          placeholder="SMS number"
          defaultValue={
            callerNumber
              ? { value: callerNumber, label: processPhoneNumber(callerNumber) }
              : undefined
          }
          onChange={(value) => {
            setCallerNumber(value);
            onConfigChange?.({ phone_number: value });
          }}
          fetchOptions={searchCallerNumbers}
        />
      </div>
    </SkillCard>
  );
}
